(function () {
  "use strict";

  if (!window.BDSMProductEngagement) return;

  const product = window.BDSMProductEngagement;

  function trackKlaviyoEvent(eventName, properties) {
    if (
      !window.klaviyo ||
      typeof window.klaviyo.track !== "function"
    ) {
      console.warn("Klaviyo is not available:", eventName);
      return false;
    }

    try {
      window.klaviyo.track(eventName, properties);
      console.log(eventName + " sent to Klaviyo");
      return true;
    } catch (error) {
      console.error(eventName + " error:", error);
      return false;
    }
  }

  /* ---------------------------------
     1. Wiederholter Produktaufruf
  --------------------------------- */

  const repeatViewStorageKey =
    "bdsm_repeat_product_view_" + String(product.id);

  const currentVisitTime = Date.now();

  let repeatViewData = {
    visitNumber: 0,
    previousVisitTime: null
  };

  try {
    const savedRepeatViewData =
      localStorage.getItem(repeatViewStorageKey);

    if (savedRepeatViewData) {
      repeatViewData = JSON.parse(savedRepeatViewData);
    }
  } catch (error) {
    console.warn("Repeat view data could not be read:", error);
  }

  const previousVisitTime = repeatViewData.previousVisitTime;
  const visitNumber =
    Number(repeatViewData.visitNumber || 0) + 1;

  try {
    localStorage.setItem(
      repeatViewStorageKey,
      JSON.stringify({
        visitNumber: visitNumber,
        previousVisitTime: currentVisitTime
      })
    );
  } catch (error) {
    console.warn("Repeat view data could not be saved:", error);
  }

  if (visitNumber > 1) {
    const minutesSincePreviousVisit = previousVisitTime
      ? Math.round(
          (currentVisitTime - previousVisitTime) / 60000
        )
      : null;

    trackKlaviyoEvent("Produkt erneut aufgerufen", {
      ProductID: product.id,
      ProductName: product.title,
      ProductHandle: product.handle,
      VisitNumber: visitNumber,
      PreviousVisit: previousVisitTime
        ? new Date(previousVisitTime).toISOString()
        : null,
      MinutesSincePreviousVisit: minutesSincePreviousVisit
    });
  }

  /* ---------------------------------
     2. Gravur begonnen
  --------------------------------- */

  let engravingStarted = false;

  const engravingInput = document.querySelector(
    'input[name="properties[Gravur]"]'
  );

  if (engravingInput) {
    engravingInput.addEventListener("input", function () {
      if (engravingStarted) return;

      const engravingValue = this.value.trim();

      if (engravingValue.length === 0) return;

      engravingStarted = true;

      trackKlaviyoEvent("Engraving Started", {
        ProductID: product.id,
        ProductName: product.title,
        ProductHandle: product.handle,
        EngravingLength: engravingValue.length
      });
    });
  }

  /* ---------------------------------
     3. Galerie-Interaktion
  --------------------------------- */

  let galleryInteractionSent = false;

  document.addEventListener(
    "click",
    function (event) {
      if (galleryInteractionSent) return;
      if (!(event.target instanceof Element)) return;

      const image = event.target.closest("img");

      if (!image) return;

      const imageAlt = image.alt || "";

      const isGalleryImage =
        image.classList.contains("pswp__img") ||
        Boolean(image.closest("product-media-gallery")) ||
        Boolean(image.closest(".product-media")) ||
        Boolean(image.closest(".m-product-media")) ||
        Boolean(image.closest(".swiper")) ||
        imageAlt.toLowerCase().includes("bdsm box");

      if (!isGalleryImage) return;

      const wasSent = trackKlaviyoEvent(
        "Gallery Interaction",
        {
          ProductID: product.id,
          ProductName: product.title,
          ProductHandle: product.handle,
          ImageAlt: imageAlt,
          ImageClass: String(image.className || "")
        }
      );

      if (wasSent) {
        galleryInteractionSent = true;
      }
    },
    true
  );
/* ---------------------------------
   Add-to-Cart Source Attribution
--------------------------------- */

let addToCartSourceSent = false;

document.addEventListener(
  "click",
  function (event) {
    if (addToCartSourceSent) return;
    if (!(event.target instanceof Element)) return;

    const addButton = event.target.closest(".m-add-to-cart");

    if (!addButton) return;

    const engravingInput = document.querySelector(
      'input[name="properties[Gravur]"]'
    );

    const engravingValue = engravingInput
      ? engravingInput.value.trim()
      : "";

    let source = "Main Product Button";

    const buttonRect = addButton.getBoundingClientRect();
    const isNearBottom =
      buttonRect.top > window.innerHeight * 0.65;

    if (
      addButton.closest(".sticky-cart") ||
      addButton.closest(".m-sticky-add-to-cart") ||
      isNearBottom
    ) {
      source = "Sticky Add-to-Cart Button";
    }

    const wasSent = trackKlaviyoEvent(
      "Add to Cart Source",
      {
        ProductID: product.id,
        ProductName: product.title,
        ProductHandle: product.handle,
        Price: product.price,
        Currency: product.currency,
        Source: source,
        ButtonText: addButton.innerText.trim(),
        ButtonClass: String(addButton.className || ""),
        EngravingEntered: engravingValue.length > 0,
        EngravingLength: engravingValue.length
      }
    );

    if (wasSent) {
      addToCartSourceSent = true;
    }
  },
  true
);/* ---------------------------------
   Product Added to Wishlist
--------------------------------- */

let wishlistAddedSent = false;

function isWishlistActive(button) {
  const ariaPressed = button.getAttribute("aria-pressed");
  const className = String(button.className || "").toLowerCase();

  return (
    ariaPressed === "true" ||
    className.includes("active") ||
    className.includes("added") ||
    className.includes("selected")
  );
}

document.addEventListener(
  "click",
  function (event) {
    if (wishlistAddedSent) return;
    if (!(event.target instanceof Element)) return;

    const wishlistButton = event.target.closest(".m-wishlist-button");

    if (!wishlistButton) return;

    const wasAlreadyActive = isWishlistActive(wishlistButton);

    setTimeout(function () {
      const isNowActive = isWishlistActive(wishlistButton);

      /*
       * Normalerweise wird das Event nur beim Hinzufügen gesendet.
       * Falls das Theme keinen aktiven Status setzt, gilt der erste Klick
       * trotzdem als Hinzufügen.
       */
      if (wasAlreadyActive && !isNowActive) return;

      const wasSent = trackKlaviyoEvent(
        "Product Added to Wishlist",
        {
          ProductID: product.id,
          ProductName: product.title,
          ProductHandle: product.handle,
          Price: product.price,
          Currency: product.currency,
          ButtonText: (
            wishlistButton.innerText ||
            wishlistButton.getAttribute("aria-label") ||
            "Add to wishlist"
          ).trim(),
          ButtonClass: String(wishlistButton.className || ""),
          WishlistActive: isNowActive
        }
      );

      if (wasSent) {
        wishlistAddedSent = true;
      }
    }, 300);
  },
  true
);

  /* ---------------------------------
     4. 30 Sekunden Produktinteresse
  --------------------------------- */

  let activeTime = 0;
  let engagementSent = false;

  function sendEngagementEvent() {
    if (engagementSent) return;

    const wasSent = trackKlaviyoEvent(
      "Product Engagement 30 Seconds",
      {
        ProductID: product.id,
        ProductName: product.title,
        ProductHandle: product.handle,
        Price: product.price,
        Currency: product.currency,
        TimeSpent: activeTime
      }
    );

    if (wasSent) {
      engagementSent = true;
    }
  }

  const timer = setInterval(function () {
    if (document.hidden) return;

    activeTime += 1;

    if (activeTime >= 30) {
      clearInterval(timer);
      sendEngagementEvent();
    }
  }, 1000);
})();